import type { ReactNode } from "react";
import { Box, Text, type Omittable } from "@salestrak/ui";

/**
 * Compact empty state for summary-widget bodies. With children, each
 * `WidgetEmptyActionRow` (the library's ghost action row) stands in for the
 * list rows that are not there yet — muted icon + label, left-aligned, hover
 * wash — so the rows ARE the guidance and no centered well inflates the tile.
 * Without children (search-empty, unlinked states) it is a single muted
 * left-aligned line. Full-page tabs keep the large library empty states; the
 * summary does not: a tile-height well between content-hugging sections reads
 * as the tallest thing on the page.
 */
export function WidgetEmptyState({
  message,
  children,
}: Omittable<{
  /** The one-liner for states with no affordance to offer. Not rendered when
   *  action rows are present — the rows are the guidance. */
  message?: string;
  /** `WidgetEmptyActionRow` rows, each optionally wrapped by the picker or
   *  dialog it opens. */
  children?: ReactNode;
}>) {
  if (children) {
    return <Box>{children}</Box>;
  }
  return (
    <Box paddingX="sm" paddingY="sm">
      <Text color="muted" size="sm">
        {message}
      </Text>
    </Box>
  );
}
